import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class EmailOrPhoneFormValidationStrategy extends FormValidationStrategy{

    constructor() {
        super();
        this.emailRegex = /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/;
        this.phoneRegex = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){9,14}(\s*)?$/;
    }
    validate(valueString, isRequired) {
        const value = valueString
            .toString()
            .trim()
        ;

        let isValid = false;


        if ( !value.length && isRequired) {
            return {
                isValid,
                message: this.loadErrorMessage("empty", "E-mail/Телефон")
            }
        }

        if ( this.isEmailOrPhone(value) === 'invalid' ) {
            return {
                isValid,
                message: this.loadErrorMessage("regexp", "E-mail или номер телефона")
            }
        }

        isValid = true;

        return {
            isValid,
            message: ""
        }
    }

    isEmailOrPhone(value) {
        if (this.emailRegex.test(value)) {
            return 'email';
        } else if (this.phoneRegex.test(value)) {
            return 'phone';
        } else {
            return 'invalid';
        }
    }
}
